export default {
  administration: 'Administration',
  companies: 'Companies',
  companyAuthorized: 'Home',
  companyReviews: 'Reviews',
  dashboard: 'Home',
  editCompany: 'Edit',
  editService: 'Edit',
  navigation: 'Navigation',
  serviceAuthorized: 'Home',
  calendar: 'Calendar',
  products: 'Products',
  serviceReviews: 'Reviews',
  services: 'Services'
}



// WEBPACK FOOTER //
// ./src/i18n/en/navigation.js